// Platform constants
export const giroTechLogo = "https://giro-logos.s3.us-east-1.amazonaws.com/public/logo-full.png";
export const giroTechPlatformName = "Giro.Tech Academy";

// Quiz constants
export const QUIZ_PASSING_SCORE = 80;

// Video tracking constants
export const VIDEO_COMPLETION_THRESHOLD = 0.9; // 90% watched

// Social sharing
export const LINKEDIN_SHARE_BASE_URL = "https://www.linkedin.com/sharing/share-offsite/";
